import {
  FiUsers,
  FiUserPlus,
  FiTrendingUp,
  FiCheckCircle,
} from "react-icons/fi";
import SuperAdminAgentBuilderList from "../../components/super-admin/SuperAdminAgentBuilderList";

// Stats Data
const statsData = [
  {
    id: 1,
    title: "No. of Agents",
    value: "50",
    link: "View all Leads",
    percentage: "0.29%",
    isPositive: true,
    icon: FiUserPlus,
    iconBg: "#735DFF",
  },
  {
    id: 2,
    title: "Property by Agents",
    value: "200",
    link: "complete revenue",
    percentage: "3.45%",
    isPositive: false,
    icon: FiUsers,
    iconBg: "#FF5A29",
  },
  {
    id: 3,
    title: "Active Deals",
    value: "70",
    link: "Total page views",
    percentage: "11.54%",
    isPositive: true,
    icon: FiTrendingUp,
    iconBg: "#0CC763",
  },
  {
    id: 4,
    title: "Deal Closed",
    value: "40",
    link: "Total profit earned",
    percentage: "0.18%",
    isPositive: true,
    icon: FiCheckCircle,
    iconBg: "#0C9CFC",
  },
];

// Stat Card Component
const StatCard = ({
  title,
  value,
  link,
  percentage,
  isPositive,
  icon: Icon,
  iconBg,
}) => (
  <div className="bg-background-card rounded-lg p-4 sm:p-5 shadow-sm">
    <div className="flex justify-between items-start mb-4">
      <div>
        <p className="text-text-primary font-medium text-sm mb-2">{title}</p>
        <h3 className="text-2xl font-semibold text-text-primary">{value}</h3>
      </div>
      <div
        className="w-12 h-12 rounded-full flex items-center justify-center"
        style={{ backgroundColor: iconBg }}
      >
        <Icon className="text-white text-xl size-7" />
      </div>
    </div>
    <div className="flex justify-between items-center">
      <button className="text-text-muted capitalize leading-relaxed underline underline-offset-2 cursor-pointer text-sm hover:text-primary">
        {link}
      </button>
      <span
        className={`text-sm font-semibold ${
          isPositive ? "text-status-success" : "text-status-danger"
        }`}
      >
        {percentage}
      </span>
    </div>
  </div>
);

// Main Component
const SuperAdminAgentBuilder = () => {
  return (
    <div className="min-h-screen font-quicksand bg-background py-3 sm:py-4 md:py-6 pl-3 sm:pl-4 md:pl-6 pr-2 sm:pr-3 md:pr-4">
      {/* Stats Grid */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 ">
        {statsData.map((stat) => (
          <StatCard key={stat.id} {...stat} />
        ))}
      </div>
      <div className="mt-6">
        <SuperAdminAgentBuilderList />
      </div>
    </div>
  );
};

export default SuperAdminAgentBuilder;
